/**
 * gs-card-qty — sélecteur de grammes (− / +) sur les cartes produit vendues au gramme.
 * Écouteur délégué au niveau du document → survit aux re-rendus AJAX des facettes
 * et fonctionne pour toutes les cartes présentes ou ré-injectées.
 */
(function () {
  function onClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const btn = target.closest('.gsc-qty__btn');
    if (!btn) return;
    const wrap = btn.closest('.gsc-qty');
    const input = wrap && wrap.querySelector('.gsc-qty__input');
    if (!input) return;
    const min = parseInt(input.getAttribute('min') || '1', 10);
    const delta = parseInt(btn.getAttribute('data-step') || '0', 10);
    let val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;
    val = Math.max(min, val + delta);
    input.value = String(val);
  }

  function onChange(event) {
    const input = event.target;
    if (!(input instanceof Element) || !input.classList.contains('gsc-qty__input')) return;
    const min = parseInt(input.getAttribute('min') || '1', 10);
    let val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) val = min;
    input.value = String(val);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
})();
